import { render, staticRenderFns } from "./AgbPopup.vue?vue&type=template&id=48fca73c&scoped=true"
import script from "./AgbPopup.vue?vue&type=script&lang=js"
export * from "./AgbPopup.vue?vue&type=script&lang=js"
import style0 from "./AgbPopup.vue?vue&type=style&index=0&id=48fca73c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48fca73c",
  null
  
)

export default component.exports